import { Utils } from '@qality/common-utils';

export const toText = (logs) => {
  return logs
    ?.map((log) => {
      let text = !Utils.isNilOrEmpty(log.name) ? log.name : '';
      text += '\n';
      text += errorObjToText(log.details.errors);
      text += arrayOfErrorsToText(log.details.errorMessages);
      return text;
    })
    .reduce((previousValue, currentValue) => {
      return previousValue + '\n' + currentValue;
    });
};

function errorObjToText(errorObj) {
  return arrayOfErrorsToText(Object.values(errorObj));
}

function arrayOfErrorsToText(arrayOfErrors) {
  if (!Utils.isNilOrEmpty(arrayOfErrors)) {
    return arrayOfErrors.reduce((previousValue, currentValue) => {
      return previousValue + '\n' + currentValue;
    });
  }

  return '';
}
